import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '@lmc-app/shared/interface/user.interface';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalDashboardService {
  private readonly uri: string = `${environment.DO_URL}/v2`;
  constructor(private readonly http: HttpClient) {}

	getExternalDashboardColumnConfig(agencyId: string) {
		const data = { agencyId };
		return this.http.post(`${this.uri}/getExternalDashboardColumnConfig`, data);
	}

	getExternalAgencyList(agencyId: string, currentUser:User) {
		const data = { agencyId, currentUser };
		return this.http.post(`${this.uri}/getExternalAgencyList`, data);
	}

	getExternalAgencyNotes(zoho_app_record_id: any, subjects: string[]): Observable<any> {
		const data = {
			zoho_app_record_id,
			subjects
		};
		return this.http.post(`${this.uri}/getExternalAgencyNotes`, data);
	}
}
